"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Input_InvalidDateTimeValue: "'{0}' is not a valid UTC Date Time.  Please enter date and time in {1} format.",
            }
        });
        /**
         * Framework class for DateTime controls
         */
        var DateTime = /** @class */ (function (_super) {
            __extends(DateTime, _super);
            function DateTime() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            DateTime.getFormattedValue = function (value, control) {
                var maxDateAsString = moment($dyn.util.time.maxDate).utc().format("YYYY-MM-DD");
                var result;
                if ($dyn.value(control.MaxDateLabel) && value === maxDateAsString) {
                    // They are using the max date, replace the value with the max date label.
                    result = $dyn.value(control.MaxDateLabel);
                }
                else {
                    if (value.indexOf("T") !== -1) {
                        // If the date contains a time portion add the Z so all browser parse the value consistently.
                        value += "Z";
                    }
                    else {
                        // If it is just a date add a time portion to force it to parse as UTC.
                        value += "T00:00:00Z";
                    }
                    // The value should come down from the server in ISO 8601 standard date format so it can be used by the JS Date constructor
                    var valueAsDate = new window.Date(value);
                    var dateAsMoment = moment(valueAsDate);
                    if (!control.TimeZonePreference || $dyn.value(control.TimeZonePreference) === $dyn.util.TimeZonePreference.none) {
                        dateAsMoment.utc();
                    }
                    else {
                        dateAsMoment.tz("User");
                    }
                    var dateFormat = $dyn.util.getDateFormat(control);
                    var formatPatterns = dateFormat;
                    if (control instanceof DateTime) {
                        var timeFormat = $dyn.util.getTimeFormat(control);
                        if ($dyn.value(control.DisplayOption) !== "Date" && timeFormat.display !== "") {
                            // Save off the orginal dateParseformats so we can use them later
                            var dateParseFormats = dateFormat.parse.slice();
                            // Combine the date and time formats.
                            var addToPatterns_1 = (formatPatterns.display ? " " : "") + timeFormat.display;
                            formatPatterns.display += addToPatterns_1;
                            formatPatterns.parse.forEach(function (val, index, array) {
                                array[index] = val + addToPatterns_1;
                            });
                            // Add formats for just having the date portion.
                            Array.prototype.push.apply(formatPatterns.parse, dateParseFormats);
                        }
                    }
                    result = dateAsMoment.format(formatPatterns.display);
                }
                return result;
            };
            DateTime.prototype.getTodayMoment = function () {
                var todayMoment = moment();
                todayMoment = this._applyTimeZonePreference(todayMoment);
                var currentTime = this.getMoment();
                if (moment.isMoment(currentTime) && currentTime.isValid()) {
                    todayMoment = moment($dyn.util.combineDateAndTime(todayMoment, currentTime));
                }
                return todayMoment;
            };
            DateTime.prototype.getSessionDateMoment = function () {
                if ($dyn.user().UserSessionDate()) {
                    // userSessionDate is already date/time and timezone set
                    var userMoment = moment.tz($dyn.user().UserSessionDate(), "User");
                    var currentTime = this.getMoment();
                    if (moment.isMoment(currentTime) && currentTime.isValid()) {
                        userMoment = moment($dyn.util.combineDateAndTime(userMoment, currentTime));
                    }
                    return userMoment;
                }
                return this.getTodayMoment();
            };
            DateTime.prototype._createFormatPatterns = function () {
                var _this = this;
                return $dyn.computed(function () {
                    var dateFormat = $dyn.util.getDateFormat(_this);
                    var timeFormat = $dyn.util.getTimeFormat(_this);
                    var formatPatterns = dateFormat;
                    if ($dyn.value(_this.DisplayOption) !== "Date" && timeFormat.display !== "") {
                        // Save off the orginal dateParseformats so we can use them later
                        var dateParseFormats = dateFormat.parse.slice();
                        // Combine the date and time formats.
                        var addToPatterns_2 = (formatPatterns.display ? " " : "") + timeFormat.display;
                        formatPatterns.display += addToPatterns_2;
                        formatPatterns.parse.forEach(function (value, index, array) {
                            array[index] = value + addToPatterns_2;
                        });
                        // Add formats for just having the date portion.
                        Array.prototype.push.apply(formatPatterns.parse, dateParseFormats);
                    }
                    return formatPatterns;
                });
            };
            return DateTime;
        }(controls.Date));
        controls.DateTime = DateTime;
        DateTime.prototype.IgnoreTime = false;
        // The value should be in the ISO 8601 standard date format.
        DateTime.prototype.valueFormatPattern = "YYYY-MM-DDTHH:mm:ss";
        DateTime.prototype.errorMessageLabel = "Input_InvalidDateTimeValue";
        DateTime.prototype.DisplayOption = $dyn.ui.autoValue;
        DateTime.prototype.TimeZonePreference = $dyn.util.TimeZonePreference.auto;
        DateTime.prototype.TimeFormat = $dyn.ui.autoValue;
        DateTime.prototype.TimeHours = true;
        DateTime.prototype.TimeMinute = true;
        DateTime.prototype.TimeSeconds = true;
        DateTime.prototype.TimeSeparator = $dyn.ui.autoValue;
        $dyn.adapter({ id: "DateTimeSummary", controlType: "DateTime", template: "SummaryField" });
        $dyn.adapter({ id: "DateTimeLabel", controlType: "DateTime", template: "Label" });
        $dyn.adapter({ id: "DateTimeCardCell", controlType: "DateTime", template: "CardCell" });
        var DateTimeCell = /** @class */ (function (_super) {
            __extends(DateTimeCell, _super);
            function DateTimeCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            DateTimeCell.prototype.updateValue = function () {
                return this._onChange();
            };
            DateTimeCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            DateTimeCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            DateTimeCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            DateTimeCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            DateTimeCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            DateTimeCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(DateTimeCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return DateTimeCell;
        }(DateTime));
        controls.DateTimeCell = DateTimeCell;
        $dyn.ui.addPropertiesToPrototype(DateTimeCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "DateTime", template: "InputCell" });
        $dyn.cellAdapter({ id: "DateTime", controlType: "DateTimeCell", template: "InputCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DateTime.js.map
